// absolute imports
import { createFileRoute, redirect } from '@tanstack/react-router';

// relative imports
import {
  getSignupUrl,
  isValidLegacyAppId,
} from '../../data/app-config/legacyAppIdMapping';

export const Route = createFileRoute('/_public/$appId/signup')({
  beforeLoad: async ({ params }) => {
    const { appId } = params;

    // Validate appId
    if (!isValidLegacyAppId(appId)) {
      // Redirect to main login for invalid appIds
      throw redirect({
        to: '/login',
      });
    }

    // Get the signup URL for this appId
    const signupUrl = getSignupUrl(appId);

    if (signupUrl) {
      // Redirect to external signup page
      window.location.href = signupUrl;
      return;
    }

    // No specific signup URL - redirect to login (for 'tax' appId)
    throw redirect({
      to: `/${appId}/login` as any,
    });
  },
});
